import { render, staticRenderFns } from "./Spent.vue?vue&type=template&id=4c7c98b1&scoped=true&"
import script from "./Spent.vue?vue&type=script&lang=js&"
export * from "./Spent.vue?vue&type=script&lang=js&"
import style0 from "./Spent.vue?vue&type=style&index=0&id=4c7c98b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c98b1",
  null
  
)

export default component.exports